export const interactiveQuestions = [
    {
        utm_title:'編輯帶路買包包！日本復古手袋店尋寶記:',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'哪一種包包是你杯茶？',
        img1:'q1l.jpg',
        des1:'二手名牌手袋',
        url1:'https://www.she.com/fashion/2019/04/%E5%90%8D%E7%89%8C%E6%89%8B%E8%A2%8B%E8%A1%80%E6%8B%BC%E6%94%BB%E7%95%A5-chanel-%E8%A2%8B-%E5%81%87%E8%B2%A8/',
        img2:'q1r.jpg',
        des2:'全新名牌手袋',
        url2:'https://www.she.com/fashion/2019/06/%E4%BA%BA%E7%94%9F%E8%B2%B7%E7%9A%84%E7%AC%AC%E4%B8%80%E5%80%8B%E5%90%8D%E7%89%8C%E6%89%8B%E8%A2%8B%E5%8C%85%E5%85%88%E7%94%9F%E6%8E%A8%E8%96%A63%E5%80%8B%E5%85%A5%E9%96%80%E7%B6%93%E5%85%B8/',
    },
    {
        utm_title:'IG界小眾香水代表！用這些香水才能突顯你的品味…',
        icon:'icon-avatar2.png',
        account:'she.com',
        message:'還需要什麼去打造你的初夏造型？',
        img1:'q2l.jpg',
        des1:'彩妝盤',
        url1:'https://critiques.she.com/playlist/info/%E4%B8%80%E7%9B%92%E5%A4%9A%E5%8A%9F%E8%83%BD%E8%B6%85%E5%AF%A6%E7%94%A8%EF%BC%81%E6%87%B6%E5%A5%B3%E7%94%9F%E5%BF%85%E9%A0%88%E6%93%81%E6%9C%89%E7%9A%84%E5%BD%A9%E5%A6%9D%E7%9B%A4/653',
        img2:'q2r.jpg',
        des2:'有色潤唇膏',
        url2:'https://critiques.she.com/playlist/info/%E6%BB%8B%E6%BD%A4%E5%8F%88%E9%A1%AF%E8%89%B2%EF%BC%81%E6%9F%94%E8%BB%9F%E5%98%B4%E5%94%87%E5%BF%85%E5%82%99-%E6%9C%89%E8%89%B2%E6%BD%A4%E5%94%87%E8%86%8F/595',
    },
    {
        utm_title:'別亂喝祛濕茶！10個體內濕重徵狀解決方法',
        icon:'icon-avatar3.png',
        account:'she.com',
        message:'你對哪種養生方法有興趣？',
        img1:'q3l.jpg',
        des1:'濕疹肌戒口貼士',
        url1:'https://www.she.com/health/2019/05/%E9%86%AB%E7%94%9F%E5%B0%88%E6%AC%84%E6%95%8F%E6%84%9F%E8%82%8C%E6%BF%95%E7%96%B9%E6%87%89%E5%A6%82%E4%BD%95%E6%88%92%E5%8F%A3%E8%A5%BF%E9%86%AB%E4%B8%8D%E5%8F%AA%E5%BE%97/',
        img2:'q3r.jpg',
        des2:'低醣飲食法',
        url2:'https://www.she.com/health/2019/05/%E4%BD%8E%E9%86%A3%E9%A3%B2%E9%A3%9F%E6%B3%95%E7%98%A6%E8%BA%AB%E4%B9%9F%E5%8F%AF%E4%BB%A5%E5%90%83%E8%87%AA%E5%8A%A9%E9%A4%90%E8%94%A3%E9%9B%85%E6%96%87%E5%88%86%E4%BA%AB/',
    },
    {
        utm_title:'【無線耳機大對決】推介5款高CP值真無線耳機',
        icon:'icon-avatar4.png',
        account:'she.com',
        message:'你認為買藍芽耳機最重要係？',
        img1:'q4l.jpg',
        des1:'音質',
        url1:'',
        img2:'q4r.jpg',
        des2:'外形',
        url2:'',
    },
    {
        utm_title:'漫步西環-隱藏於山道的特色咖啡店',
        icon:'icon-avatar3.png',
        account:'she.com',
        message:'要遠離繁囂，想去邊到渡假？',
        img1:'q5l.jpg',
        des1:'粉紅夢幻酒店',
        url1:'https://www.she.com/living/2019/05/%E4%B8%80%E7%94%9F%E4%BA%BA%E5%BF%85%E5%AE%9A%E8%A6%81%E5%8E%BB%E4%B8%80%E6%AC%A12018%E6%89%8D%E9%96%8B%E5%B9%95-%E8%A5%BF%E7%8F%AD%E7%89%99%E7%B2%89%E7%B4%85%E5%A4%A2%E5%B9%BB%E9%85%92/',
        img2:'q5r.jpg',
        des2:'藍白希臘風民宿',
        url2:'https://www.she.com/living/2019/04/%E8%97%8D%E7%99%BD%E5%B8%8C%E8%87%98%E9%A2%A8%E5%A2%BE%E4%B8%81%E6%B0%91%E5%AE%BF%E6%8E%A8%E4%BB%8B/',
    },
    {
        utm_title:'深圳網紅美甲店',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'要改變形象，你會嘗試邊款卡通美甲？',
        img1:'q6l.jpg',
        des1:'復仇者聯盟',
        url1:'https://www.she.com/beauty/2019/05/%E5%BE%A9%E4%BB%87%E8%80%85%E8%81%AF%E7%9B%9F%E5%90%8C%E6%AC%BE%E7%BE%8E%E7%94%B2%EF%BC%81%E5%AF%B6%E7%9F%B3%E7%84%A1%E9%99%90%E6%89%8B%E5%A5%97%E6%AC%BE%E6%9C%80%E5%90%B8%E7%9D%9B/',
        img2:'q6r.jpg',
        des2:'迪士尼',
        url2:'https://www.she.com/beauty/2019/04/%E5%A4%8F%E5%A4%A9%E5%B0%B1%E6%98%AF%E8%A6%81%E8%89%B2%E5%BD%A9%E7%B9%BD%E7%B4%9B%E7%9A%84%E6%8C%87%E7%94%B2%E5%BD%A9%E7%B9%AA%EF%BC%81%E8%BF%AA%E5%A3%AB%E5%B0%BC%E4%B8%BB%E9%A1%8C%E7%BE%8E%E7%94%B2/',
    },
    {
        utm_title:'世界上6個最幸福、最值得移民國家！',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'提升幸福感還可以...',
        img1:'q7l.jpg',
        des1:'High Tea',
        url1:'https://www.she.com/living/2019/06/%E6%89%93%E5%8D%A1%E5%BF%85%E5%8E%BBbarbie-%E9%99%AA%E4%BD%A0%E4%B8%8B%E5%8D%88%E8%8C%B6/',
        img2:'q7r.jpg',
        des2:'Happy Hour',
        url2:'https://www.she.com/living/2019/06/%E6%9C%9F%E9%96%93%E9%99%90%E5%AE%9A%E7%9A%84%E6%AD%A1%E6%A8%82%E6%99%82%E5%85%89%E9%AD%94%E5%B9%BB%E5%A8%81%E5%A3%AB%E5%BF%8C-vs-%E6%85%88%E5%96%84negroni-week/',
    },
    {
        utm_title:'醫生專欄-長期在室內也會曬出斑-預防色斑方法',
        icon:'icon-avatar2.png',
        account:'she.com',
        message:'趕走色斑仲需要...',
        img1:'q8l.jpg',
        des1:'防曬霜',
        url1:'https://critiques.she.com/search/%E9%98%B2%E6%9B%AC%E3%80%80',
        img2:'q8r.jpg',
        des2:'淡斑精華',
        url2:'https://critiques.she.com/search/%E6%B7%A1%E6%96%91%E3%80%80',
    },
    {
        utm_title:'睡眠不但能減肥還有這些你意想不到的好處',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'仲有其他hea住減嘅方法...',
        img1:'q9l.jpg',
        des1:'低醣飲食法',
        url1:'https://www.she.com/health/2019/05/%e4%bd%8e%e9%86%a3%e9%a3%b2%e9%a3%9f%e6%b3%95%e7%98%a6%e8%ba%ab%e4%b9%9f%e5%8f%af%e4%bb%a5%e5%90%83%e8%87%aa%e5%8a%a9%e9%a4%90%e8%94%a3%e9%9b%85%e6%96%87%e5%88%86%e4%ba%ab/',
        img2:'q9r.jpg',
        des2:'豆腐減肥法',
        url2:'https://www.she.com/health/2019/05/%e7%94%a9%e8%82%8917kg%e9%80%a3%e5%ae%8b%e6%85%a7%e5%96%ac%e4%b9%9f%e7%86%b1%e6%8d%a7%e7%9a%84%e8%b1%86%e8%85%90%e6%b8%9b%e8%82%a5%e6%b3%95/',
    },
    {
        utm_title:'夏天戶外活動要注意！不止是西瓜 3大防中暑食物',
        icon:'icon-avatar2.png',
        account:'she.com',
        message:'夏天最怕邊個尷尬moment？',
        img1:'q10l.jpg',
        des1:'體味',
        url1:'https://www.she.com/beauty/2019/06/3%e6%8b%9b%e9%a0%90%e9%98%b2%e9%ab%94%e5%91%b3/',
        img2:'q10r.jpg',
        des2:'溶妝',
        url2:'https://www.shemom.com/fashion-and-beauty/2019/05/%E9%9D%9A%E5%AA%BDjoanne-li%E9%A6%AC%E6%8B%89%E6%9D%BE%E7%8B%82%E5%87%BA%E6%B1%97%E4%B8%8D%E8%84%AB%E5%A6%9D%E5%8C%96%E5%A6%9D%E5%93%81%E6%B8%85%E5%96%AE/',
    },
    {
        utm_title:'人妻黃翠如-凍齡秘訣',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'仲缺少邊樣黃翠如嘅凍齡法寶？',
        img1:'q11l.jpg',
        des1:'潔面產品',
        url1:'https://critiques.she.com/search/%E6%BD%94%E9%9D%A2%E3%80%80',
        img2:'q11r.jpg',
        des2:'保濕面膜',
        url2:'https://critiques.she.com/search/%E4%BF%9D%E6%BF%95%E9%9D%A2%E8%86%9C%E3%80%80',
    },
    {
        utm_title:'夏天穿吊帶最避忌告別副乳-必做5個伸展動作',
        icon:'icon-avatar3.png',
        account:'she.com',
        message:'夏天必備item，你仲差邊樣？',
        img1:'q12l.jpg',
        des1:'泳衣',
        url1:'https://www.she.com/fashion/2019/05/%e4%ba%ba%e6%b0%a3%e9%ab%98%e8%b3%aa%e6%b3%b3%e8%a1%a3%e6%b7%98%e5%af%b6%e5%ba%97%ef%bc%81%e9%a1%af%e6%b0%a3%e8%b3%aa%e4%b9%8b%e9%a4%98%e5%8f%88%e4%b8%8d%e5%ae%b9%e6%98%93%e6%92%9e%e6%ac%be/',
        img2:'q12r.jpg',
        des2:'波鞋',
        url2:'https://www.she.com/fashion/2019/04/%E7%AC%AC%E4%BA%94%E5%AD%A3adidas-originals-by-alexander-wang/',
    },
    {
        utm_title:'湯洛雯愈減愈肥！女生減肥失敗4大常犯錯誤',
        icon:'icon-avatar2.png',
        account:'she.com',
        message:'你崇尚邊個健康減肥法？',
        img1:'q13l.jpg',
        des1:'DIY飯盒',
        url1:'https://brides.she.com/wife-able/2019/05/%e5%91%a8%e9%9d%88%e5%b1%b1%e5%85%8d%e7%85%ae%e6%96%99%e7%90%86%e6%95%99%e5%ae%a4-%e6%97%a9%e9%a4%90%e7%af%87%e5%85%8d%e7%85%ae%e4%bd%8e%e7%b3%96%e8%94%ac%e6%9e%9c%e9%ba%a5/',
        img2:'q13r.jpg',
        des2:'運動',
        url2:'https://brides.she.com/style-beauty/2019/06/%E7%98%A6%E8%BA%AB%E6%95%99%E5%AE%A4-ep6%E6%83%85%E4%BE%B6%E6%B8%9B%E8%82%A5%E6%B6%88%E8%84%82%E7%88%86%E6%B1%97%E6%93%8D/',
    },
    {
        utm_title:'【醫生專欄】囊性痤瘡怎麼辦？夏天必看暗瘡急救法',
        icon:'icon-avatar3.png',
        account:'she.com',
        message:'除咗生暗瘡，你最怕...?',
        img1:'q14l.jpg',
        des1:'唇部敏感',
        url1:'https://www.she.com/health/2019/05/%e4%b8%80%e5%a4%9c%e4%b9%8b%e9%96%93%e8%ae%8a%e5%ad%96%e6%bd%a4%e8%85%b8%e5%98%b4%e5%94%87%e9%83%a8%e6%95%8f%e6%84%9f%e5%a5%ae%e9%ac%a5%e5%8f%b2/',
        img2:'q14r.jpg',
        des2:'水腫',
        url2:'https://www.she.com/health/2019/04/%e3%80%90%e9%87%8e%e4%ba%ba2%e5%88%86%e9%90%98%e7%91%9c%e4%bc%bd%e6%95%99%e5%ae%a4%e3%80%91ep1-%e6%94%be%e9%ac%86%e8%82%a9%e9%a0%b8%e7%af%87/',
    },
    {
        utm_title:'日本爸爸與女兒梳同一個髮型，為她帶來健康成長的祝願',
        icon:'icon-avatar2.png',
        account:'shemom',
        message:'如果可以重返童年，你想同父母做啲咩？',
        img1:'q15l.jpg',
        des1:'一齊shopping',
        url1:'https://www.shemom.com/hot-topics/2019/06/kids-power%e7%88%b6%e8%a6%aa%e7%af%80shopping%e5%a4%a7%e8%80%83%e9%a9%97/',
        img2:'q15r.jpg',
        des2:'去外遊',
        url2:'https://www.she.com/living/2019/07/%e6%97%a5%e6%9c%ac%e6%a9%ab%e6%bf%b1%e9%ba%b5%e5%8c%85%e8%b6%85%e4%ba%ba%e5%8d%9a%e7%89%a9%e9%a4%a8%e7%8e%a9%e6%a8%82%e6%89%93%e5%8d%a1%e6%87%b6%e4%ba%ba%e5%8c%85/',
    },
    {
        utm_title:'婚前100日肌膚大掃除︰準新娘平價去角質小秘技',
        icon:'icon-avatar1.png',
        account:'shebrides',
        message:'Big Day前一定要......',
        img1:'q16l.jpg',
        des1:'美白牙齒',
        url1:'https://brides.she.com/style-beauty/2019/03/%e6%96%b0%e5%a8%98%e7%be%8e%e7%99%bd%e7%89%99%e9%bd%923%e5%80%8b%e8%b6%85%e7%b0%a1%e5%96%ae%e6%96%b9%e6%b3%95/',
        img2:'q16r.jpg',
        des2:'敷mask',
        url2:'https://brides.she.com/style-beauty/2019/06/%e5%93%aa%e6%ac%be%e9%9d%a2%e8%86%9c%e4%bb%a4%e4%bd%a0%e6%84%9b%e4%b8%8d%e9%87%8b%e6%89%8b%e6%8e%a8%e4%bb%8b%e9%80%99%e5%9b%9b%e6%ac%be%e9%9d%a2%e8%86%9c%e6%98%93%e7%94%a8%e5%bf%ab%e8%a6%8b/',
    },
    {
        utm_title:'向頭油SAY NO 乾爽頭皮防異味',
        icon:'icon-avatar1.png',
        account:'she.com',
        message:'有咩原因會令秀髮加分？',
        img1:'q17l.jpg',
        des1:'造型',
        url1:'https://www.she.com/hair/2019/06/%e6%b8%9b%e9%bd%a1%e5%8f%aa%e5%b7%ae%e4%b8%80%e9%9a%bb%e9%ab%ae%e5%a4%be%e5%bf%85%e5%ad%b830%e7%a7%92%e9%ab%ae%e5%a4%be%e9%80%a0%e5%9e%8b%e8%ae%8a%e8%ba%ab%e8%a1%93/',
        img2:'q17r.jpg',
        des2:'香氣',
        url2:'https://brides.she.com/style-beauty/2019/07/melanie-lam%e4%bb%96%e6%9c%83%e8%a8%98%e5%be%97%e5%a6%b3%e8%ba%ab%e4%b8%8a%e7%9a%84%e9%a6%99%e5%91%b3/',
    },
    {
        utm_title:'女人也有脫髮煩惱？ 三招拯救頭髮稀疏',
        icon:'icon-avatar3.png',
        account:'shemom',
        message:'頭髮最緊要係...？',
        img1:'q18l.jpg',
        des1:'順滑光澤',
        url1:'https://brides.she.com/style-beauty/2019/06/%e5%88%a5%e8%ae%93%e9%a0%ad%e9%ab%ae%e6%90%9e%e7%a0%b4%e5%a3%9e%e6%96%b0%e5%a8%98%e8%a6%81%e6%b3%a8%e6%84%8f%e9%ab%ae%e7%b5%b2%e6%8a%97%e4%b9%be%e9%98%b2%e7%87%a5/',
        img2:'q18r.jpg',
        des2:'有女神氣質',
        url2:'https://www.she.com/hair/2019/07/%e6%b8%af%e5%a7%90%e9%ab%ae%e5%9e%8b%e8%a3%bd%e9%80%a0%e6%a9%9f%e9%99%b3%e6%9b%89%e8%8f%af%e5%92%8c%e4%bb%8a%e5%b1%86%e5%a4%a7%e7%86%b1%e7%9a%84%e6%b0%a3%e8%b3%aa%e9%ab%ae%e5%9e%8b%e9%83%bd/',
    },
    {
        utm_title:'是大媽還是美魔女？日本名模校長教你改習慣年輕10年',
        icon:'icon-avatar2.png',
        account:'shebrides',
        message:'眼睛係最容易出賣年齡嘅地方，你最關注...？',
        img1:'q19l.jpg',
        des1:'眼紋',
        url1:'https://www.she.com/beauty/2019/06/%e6%88%80%e7%89%a9pick-%e7%9c%bc%e7%b4%8b-%e7%9c%bc%e9%9c%9c/',
        img2:'q19r.jpg',
        des2:'黑眼圈',
        url2:'https://www.she.com/beauty/2019/07/%e6%98%93%e6%8e%a8%e9%81%ae%e7%91%95%e9%ab%98%e7%b7%a8%e8%bc%af%e7%a7%81%e5%bf%83%e6%8e%a8%e4%bb%8b-5%e5%a4%a7%e5%a5%bd%e7%94%a8%e9%81%ae%e7%91%95%e8%86%8f/',
    },
    {
        utm_title:'張松枝控訴！兒子被狗咬漁護署回覆令他很無助',
        icon:'icon-avatar3.png',
        account:'shemom',
        message:'當小朋友好驚時，作為家長你會點做？',
        img1:'q20l.jpg',
        des1:'陪伴在側',
        url1:'https://www.shemom.com/motherhood/2019/06/%e4%bb%81%e6%bf%9f%e9%86%ab%e9%99%a2%e4%bb%94%e5%a5%b3%e5%a4%a7%e5%8f%ab%e5%a5%bd%e9%a9%9a%e7%88%b6%e6%af%8d%e5%8f%af%e4%bb%a5%e9%bb%9e%e5%81%9a-%e9%9b%b7%e9%9b%a8%e8%99%b9%e5%a7%91%e5%a8%98/',
        img2:'q20r.jpg',
        des2:'與他傾訴',
        url2:'https://www.shemom.com/hot-topics/2019/06/%e9%9b%bb%e8%a6%96%e6%96%b0%e8%81%9e%e6%87%89%e8%a9%b2%e6%b7%b1%e5%85%a5%e8%a8%8e%e8%ab%96%e9%82%84%e6%98%af%e9%81%bf%e8%80%8c%e4%b8%8d%e8%ab%87/',
    },
    {
        utm_title:'生酮飲食好與壞 哪幾種人不該生酮？',
        icon:'icon-avatar2.png',
        account:'shebrides',
        message:'如果唔keep fit，結婚後你最想同另一半...',
        img1:'q21l.jpg',
        des1:'幸福肥',
        url1:'https://brides.she.com/style-beauty/2019/08/%e5%b9%b8%e7%a6%8f%e8%82%a5%e5%8e%9f%e4%be%86%e4%bf%82%e7%9c%9f%e7%a0%94%e7%a9%b6%e5%a9%9a%e5%be%8c%e5%a4%ab%e5%a6%bb%e6%9c%83%e4%b8%80%e9%bd%8a%e8%82%a5/',
        img2:'q21r.jpg',
        des2:'保持戀愛感',
        url2:'https://brides.she.com/wife-able/2019/07/%e7%8f%be%e4%bb%a3%e5%a4%ab%e5%a6%bb%e7%9b%b8%e8%99%95%e4%b9%8b%e9%81%93%ef%b8%b05%e6%8b%9b%e4%bb%a4%e5%a9%9a%e5%a7%bb%e4%bf%9d%e6%8c%81%e6%88%80%e6%84%9b%e6%84%9f/',
    },
    {
        utm_title:'送你海洋公園海賊王親子夏水戰門票！',
        icon:'icon-avatar1.png',
        account:'shecom',
        message:'送你海洋公園海賊王親子夏水戰門票！',
        img1:'q22l.jpg',
        des1:'立即登記',
        url1:'https://campaigns.she.com/shemom/oceanpark/',
        img2:'q22r.jpg',
        des2:'活動詳情',
        url2:'https://campaigns.she.com/shemom/oceanpark/',
    },
    {
        type:'banner',
        utm_title:'免費每日英語電郵 學用得著既英語重新出發!',
        utm_term:'edm-ef',
        img1:'q23.gif',
        url1:'https://www.she.com/edm/教你同外國人吹水/',
    },
    {
        type:'banner',
        utm_title:'【運動型女生限定耳機】高質無線耳機陪你挑戰極限',
        utm_term:'jaybird',
        img1:'q24.gif',
        url1:'https://www.she.com/fashion/2019/08/運動型女生限定耳機高質無線耳機陪你挑戰極/',
    },
    {
        type:'banner',
        utm_title:'與小朋友渡過刺激的一天 | 立即報名shemom x SuperPark HK 繽Fun派對',
        utm_term:'superparkhk',
        img1:'q25.jpg',
        url1:'https://www.she.com/she-mom/2019/08/%E8%88%87%E5%B0%8F%E6%9C%8B%E5%8F%8B%E6%B8%A1%E9%81%8E%E5%88%BA%E6%BF%80%E7%9A%84%E4%B8%80%E5%A4%A9-%E7%AB%8B%E5%8D%B3%E5%A0%B1%E5%90%8Dshemom-x-superpark-hk-%E7%B9%BDfun%E6%B4%BE%E5%B0%8D/',
    },
]


// WEBPACK FOOTER //
// ./sites/she.com/js/interactiveQuestions.js